import { Navigate } from 'react-router-dom';

import { useAuthStore } from '../store/auth/auth.store';

export interface AuthRouteProps {
  children: React.ReactNode;
}

const AuthRoutes: React.FC<AuthRouteProps> = ({ children }) => {
  const token = useAuthStore(s => s.token);

  return !token ? children : <Navigate to="/dashboard" replace />;
};

export default AuthRoutes;
